var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerifiedProfessional(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.055 7H3.943a3.611 3.611 0 00-3.611 3.61c0 .4.323.724.722.724h7.889c.4 0 .723-.323.723-.723A3.61 3.61 0 006.056 7zm-4.708 3.334A2.614 2.614 0 013.943 8h2.112c1.346 0 2.44 1.024 2.596 2.334H1.347zM4.999 6a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zm0-4.334c.919 0 1.667.748 1.667 1.667C6.666 4.253 5.918 5 4.999 5a1.669 1.669 0 01-1.667-1.667c0-.919.748-1.667 1.667-1.667zm8.506 1.8a.5.5 0 00-.706.027l-1.814 1.953-.8-.8a.5.5 0 10-.707.707l1.167 1.167c.094.095.22.147.354.147h.01a.5.5 0 00.357-.16l2.166-2.334a.501.501 0 00-.027-.706z",
    fill: "#028BB7"
  })));
}

export default SvgVerifiedProfessional;